import React, { useState } from 'react';
import useFetchTableData from 'hooks/useFetchTableData';
import DocsRequestTemplatesServices from 'services/api/DocsRequestTemplates';
import AdminContainer from 'components/Admin/AdminContainer';
import { useParams } from 'react-router-dom';
import { DocRequestTemplateCategoryType } from 'types/DocRequestTemplate';
import DocsRequestTemplateView from './components/View';

function DocsRequestTemplateSscreen() {
  const { type } = useParams();

  const [physicalReloaded, setPhysicalReloaded] = useState( new Date().valueOf() );
  const [fiscalReloaded, setFiscalReloaded] = useState( new Date().valueOf() );
  const [investmentsReloaded, setInvestmentsReloaded] = useState( new Date().valueOf() );

  const {
    fetchData: fetchPhysicalData,
    data: physicalData,
    dataLoading: physicalDataLoading,
  } = useFetchTableData( {
    promise: ( params ) => DocsRequestTemplatesServices.getTemplates( {
      ...params,
      Filter: `categoria##${DocRequestTemplateCategoryType.physical}`,
    } ),
    deps: [physicalReloaded],
  } );

  const {
    fetchData: fetchFiscalData,
    data: fiscalData,
    dataLoading: fiscalDataLoading,
  } = useFetchTableData( {
    promise: ( params ) => DocsRequestTemplatesServices.getTemplates( {
      ...params,
      Filter: `categoria##${DocRequestTemplateCategoryType.fiscal}`,
    } ),
    deps: [fiscalReloaded],
  } );

  const {
    fetchData: fetchInvestmentsData,
    data: investmentsData,
    dataLoading: investmentsDataLoading,
  } = useFetchTableData( {
    promise: ( params ) => DocsRequestTemplatesServices.getTemplates( {
      ...params,
      Filter: `categoria##${DocRequestTemplateCategoryType.investments}`,
    } ),
    deps: [investmentsReloaded],
  } );

  return (
    <AdminContainer
      type={type}
    >
      <DocsRequestTemplateView
        data={physicalData}
        category={DocRequestTemplateCategoryType.physical}
        fetchData={fetchPhysicalData}
        isLoading={physicalDataLoading}
        reloadData={() => setPhysicalReloaded( new Date().valueOf() )}
      />
      <DocsRequestTemplateView
        data={fiscalData}
        category={DocRequestTemplateCategoryType.fiscal}
        fetchData={fetchFiscalData}
        isLoading={fiscalDataLoading}
        reloadData={() => setFiscalReloaded( new Date().valueOf() )}
      />
      <DocsRequestTemplateView
        data={investmentsData}
        category={DocRequestTemplateCategoryType.investments}
        fetchData={fetchInvestmentsData}
        isLoading={investmentsDataLoading}
        reloadData={() => setInvestmentsReloaded( new Date().valueOf() )}
      />
    </AdminContainer>
  );
}

export default DocsRequestTemplateSscreen;
